import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoSearchOutline, IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import SkeletonOne from "../../skeleton/SkeletonOne";
import {
    removeFollowers,
    UserAccountFollow,
    UserAccountFollowerlist,
    UserAccountFollowinglist,
    otherUserFollowersList,
} from "../../../redux/ApiSlice/AccountProfileSlice";
import { getAndCreateChatRoom } from "../../../redux/ApiSlice/MessagesSlice";
import { set } from "lodash";

export const FollowersTab = ({ datalist, otheruser_id, searchTerm = "", hasMore = false, loadingMore = false, onLoadMore, serverFiltered = false, searching = false }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const { User_profile, loading } = ProfileDetails || {};

    const [filteredList, setFilteredList] = useState([]);
    const [sentinelEl, setSentinelEl] = useState(null);

    useEffect(() => {
        if (!hasMore || loadingMore || searchTerm || !sentinelEl) return;
        const observer = new IntersectionObserver(
            ([entry]) => { if (entry.isIntersecting) onLoadMore?.(); },
            { threshold: 0 }
        );
        observer.observe(sentinelEl);
        return () => observer.disconnect();
    }, [hasMore, loadingMore, searchTerm, onLoadMore, sentinelEl]);

    const handleFollowFun = async (userId) => {
        const res = await dispatch(UserAccountFollow(userId));
        if (otheruser_id) {
            await dispatch(otherUserFollowersList(otheruser_id));
        }
        if (!res.payload.requested) {

            setFilteredList((prevList) =>
                prevList.map((item) =>
                    item.follower_id === userId
                        ? { ...item, is_following: !item.is_following }
                        : item
                )
            );
        }
        else {
            setFilteredList((prevList) =>
                prevList.map((item) =>
                    item.follower_id === userId
                        ? { ...item, requested: !item.requested }
                        : item
                )
            );
        }
    };

    const handleStartChat = async (userId) => {
        try {
            const response = await dispatch(getAndCreateChatRoom(userId));
            if (response.payload && response.payload.id) {
                navigate(`/message/${response.payload.id}`);
            }
        } catch (error) {
            console.error("Error starting chat:", error);
        }
    };

    const deleteFollowFun = async (userId) => {
        try {
            await dispatch(removeFollowers(userId));
            await dispatch(UserAccountFollowerlist());
        } catch (error) {
            console.error("Error unfollowing user:", error);
        }
    }

    useEffect(() => {
        if (serverFiltered || !searchTerm) {
            setFilteredList(datalist || []);
        } else {
            const lower = searchTerm.toLowerCase();
            setFilteredList(
                (datalist || []).filter(item =>
                    (`${item?.follower_full_name}`.toLowerCase().includes(lower))
                )
            );
        }
    }, [searchTerm, datalist, serverFiltered]);

    return (
        <section className="h-full overflow-y-auto">
            {loading ? (
                <SkeletonOne />
            ) : filteredList?.length ? (
                <div className="pb-4">
                    {filteredList?.map((item) => (
                        <div key={item.id} className="flex items-center py-2 border-b border-gray-300 dark:border-gray-800/50">
                            <div className="grid grid-cols-12  justify-between w-full px-2">
                                <div className="col-span-7 flex items-start gap-x-1.5 rounded-full">
                                    <img
                                        src={item?.follower_avatar_url}
                                        onClick={() => navigate(User_profile.id == item?.follower_id ? `/account` : `/account/${item?.follower_id}`)}
                                        className="h-10 w-10 rounded-full object-cover cursor-pointer border border-gray-300 dark:border-gray-800/50 bg-gray-100 dark:bg-gray-800/50"
                                    />
                                    <div className="flex flex-col">
                                        <p
                                            onClick={() => navigate(User_profile.id == item?.follower_id ? `/account` : `/account/${item?.follower_id}`)}
                                            className="text-[11px] first-letter:uppercase whitespace-nowrap font-bold dark:text-white text-gray-600"
                                        >
                                            {item?.follower_full_name}
                                        </p>
                                        <div className={`flex items-center gap-x-1 ${item?.mutual_friends?.length !== 0 && "mt-1"}`}>
                                            <div className="flex -space-x-2 overflow-hidden">
                                                {item?.mutual_friends?.map((friends, index) => (
                                                    <>
                                                        {index < 3 && (
                                                            <img
                                                                alt="img"
                                                                src={friends?.avatar_url}
                                                                onClick={() => navigate(`/mutual-friends/${item?.follower_id}`)}
                                                                className="inline-block h-4 w-4 rounded-full object-cover cursor-pointer"
                                                            />
                                                        )}
                                                    </>
                                                ))}
                                            </div>
                                            <p className={`text-[10px] text-gray-400 dark:text-gray-500 cursor-pointer whitespace-nowrap ${item?.mutual_friends?.length === 0 && "-ml-1"}`}>
                                                {item?.mutual_friends?.length > 0
                                                    ? `${item.mutual_friends.length} mutual`
                                                    : "No mutual"
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {User_profile?.id !== item?.follower_id &&
                                    <div className="col-span-5 flex items-center justify-end gap-x-3">
                                        {item.is_follower && item.is_following && !otheruser_id ? (
                                            <button
                                                onClick={() => handleStartChat(item?.follower_id)}
                                                className="w-[4.2rem] bg-gray-800 dark:bg-[#333333] hover:bg-gray-900 text-white text-[10px] font-semibold py-1 rounded-md whitespace-nowrap"
                                            >
                                                Message
                                            </button>
                                        ) : item.is_follower && !item.is_following ? (
                                            <button
                                                onClick={() => item.requested ? null : handleFollowFun(item?.follower_id)}
                                                className="w-[4.2rem] bg-[#BDE6FF] hover:bg-[#A0D8FF] text-black text-[10px] font-semibold py-1 rounded-md whitespace-nowrap"
                                            >
                                                {item.requested ? "Requested" : "Follow Back"}
                                            </button>
                                        ) : !item.is_follower && item.is_following || item.is_follower && item.is_following ? <button
                                            onClick={() => handleFollowFun(item?.follower_id)}
                                            className="w-[4.2rem] bg-gray-800 hover:bg-gray-900 text-white text-[10px] font-semibold py-1 rounded-md whitespace-nowrap"
                                        >
                                            Following
                                        </button> : <button
                                            onClick={() => handleFollowFun(item?.follower_id)}
                                            className="w-[4.2rem] bg-[#BDE6FF] hover:bg-[#A0D8FF] text-black text-[10px] font-semibold py-1 rounded-md whitespace-nowrap"
                                        >
                                            Follow
                                        </button>}
                                        {!otheruser_id &&
                                            <button onClick={() => deleteFollowFun(item.follower_id)} className="bg-gray-200 dark:bg-white hover:bg-gray-300 text-gray-900 dark:text-black text-[10px] p-1 rounded-md">
                                                <IoClose className="text-[16px]" />
                                            </button>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    ))}
                    {!searchTerm && (
                        <div ref={setSentinelEl} className="flex justify-center py-4">
                            {loadingMore && <span className="text-[12px] text-gray-400 dark:text-gray-500">Loading...</span>}
                        </div>
                    )}
                </div>
            ) : (
                <div className="flex justify-center items-center h-[50%] w-full">
                    <p className="text-[12px] text-gray-600 dark:text-gray-200 mt-5">
                        {searching ? 'Searching...' : searchTerm ? 'No result found' : 'When people follow you, they will show here'}
                    </p>
                </div>
            )}
        </section>
    );
};